import { useLazyQuery, useMutation, useQuery, } from '@apollo/client';
import { ErrorContext, } from '@thoughtspot/blink-context';
import gql from 'graphql-tag';
import { useContext, useState } from 'react';
import { containsError, getErrorObjectFromGraphQLErrors } from '../error-utils';
const useErrorPropagationHook = (handledErrors, query, errorMappingContext) => {
    const errorCtx = useContext(ErrorContext);
    const [handledErrorsCopy, setHandledErrorsCopy] = useState(handledErrors);
    const setError = (err) => {
        if (!err)
            return;
        const errors = getErrorObjectFromGraphQLErrors(err, query, errorMappingContext);
        if (!errors)
            return;
        if (containsError(errors, handledErrorsCopy))
            return;
        errorCtx.postError(errors);
    };
    return {
        setError,
    };
};
const useQueryWrapper = (query, options) => {
    const { setError } = useErrorPropagationHook(options?.handledErrors, query, options?.errorMappingContext);
    const opts = {
        ...options,
    };
    if (options?.onError) {
        opts.onError = error => {
            setError(error);
            return options?.onError?.(error);
        };
    }
    const result = useQuery(query, opts);
    if (result.error && !options?.onError) {
        setError(result.error);
    }
    return result;
};
const useMutationWrapper = (mutation, options = {}) => {
    const { setError } = useErrorPropagationHook(options?.handledErrors, mutation, options?.errorMappingContext);
    const opts = {
        ...options,
    };
    if (options?.onError) {
        opts.onError = error => {
            setError(error);
            return options?.onError?.(error);
        };
    }
    const result = useMutation(mutation, opts);
    if (result?.[1]?.error && !options?.onError) {
        setError(result?.[1]?.error);
    }
    return result;
};
const useLazyQueryWrapper = (query, options) => {
    const { setError } = useErrorPropagationHook(options?.handledErrors, query, options?.errorMappingContext);
    const opts = {
        ...options,
    };
    if (options?.onError) {
        opts.onError = error => {
            setError(error);
            return options?.onError?.(error);
        };
    }
    const result = useLazyQuery(query, opts);
    if (result?.[1]?.error && !options?.onError) {
        setError(result?.[1]?.error);
    }
    return result;
};
export * from '@apollo/client';
export { useQueryWrapper as useQuery, useMutationWrapper as useMutation, useLazyQueryWrapper as useLazyQuery, gql, };
//# sourceMappingURL=custom-apollo-hooks.js.map